import TeacherBtnLogo from "../../../Assets/HomeAssets/TeacherBtnLogo.png";
import StudentBtnLogo from "../../../Assets/HomeAssets/StudentBtnLogo.png";
import ParentBtnLogo from "../../../Assets/HomeAssets/ParentBtnLogo.png";

const HomeData = [
  {
    path: "/stafflogin",
    imgSrc: TeacherBtnLogo,
    altText: "TeacherAccessLogo",
    title: "Staff Account",
    description: "I’m an HR/Admin/IT Specialist",
  },
];

export default HomeData;
